<div class="flex flex-column w-100 overflow-auto" id="container">
    <app-ramp-view-pair-chat class="h-100" *ngIf="messageGroup?.chatGroupId" [user]="messageGroup.__user__" [chatGroupId]="messageGroup.chatGroupId" [pair]="data" [showPairInfoControl]="showInfoActive" [isNotModal]="true"></app-ramp-view-pair-chat>
</div>
